const styles = {
  root: {
    pb: 6,
    pt: { xs: 4, md: 9 },
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    rowGap: 1,
    backgroundColor: '#fff',
    width: '100%',
  },

  title: {
    fontWeight: 600,
    maxWidth: '600px!important',
    pr: 1,
    pl: 1,
    '& .MuiTypography-root': {
      color: 'text.primaryDark',
    },
  },

  subtitle: {
    maxWidth: '600px',
    color: 'common.black',
    mt: 3,
    pr: 1,
    pl: 1,
  },
  cts: {
    flexDirection: 'column',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },

}

export default styles
